export default [
    {text: "Admin", value: "admin"},
    {text: "Admin Observer", value: "admin_observer"},
    {text: "User", value: "user"}
]